import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.object.get-own-property-descriptor";
import "core-js/modules/es.object.get-own-property-descriptors";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/es.string.starts-with";
import "core-js/modules/es.string.link";
import "core-js/modules/web.dom-collections.for-each";
import "core-js/modules/web.dom-collections.iterator";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import classnames from 'classnames';
import { Link as RouterLink } from 'react-router-dom';
import { useLanguage } from "../../../i18n";
import { useLinkContext } from "../../../context";
import styles from './Link.scss';

var Link = function Link(_ref) {
  var children = _ref.children,
      className = _ref.className,
      target = _ref.target,
      to = _ref.to,
      history = _ref.history,
      rel = _ref.rel;

  var _useLinkContext = useLinkContext(),
      contextHistory = _useLinkContext.history;

  var _useLanguage = useLanguage(),
      toLocalizedRoute = _useLanguage.toLocalizedRoute;

  var localizedToObject = function localizedToObject(path) {
    return _objectSpread({}, to, {
      pathname: path ? toLocalizedRoute(path) : path
    });
  };

  var link = _typeof(to) === 'object' ? localizedToObject(to.pathname) : toLocalizedRoute(to);
  var isExternalLink = typeof link === 'string' && !link.startsWith('/');
  var isHistory = typeof history === 'boolean' ? history : contextHistory;

  if (!isHistory || isExternalLink) {
    return /*#__PURE__*/React.createElement("a", {
      href: _typeof(link) === 'object' ? link.pathname : link,
      target: target,
      className: classnames(styles.link, className),
      rel: rel
    }, children);
  }

  return /*#__PURE__*/React.createElement(RouterLink, {
    to: link,
    target: target,
    className: classnames(styles.link, className)
  }, children);
};

export default Link;